import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Draggable } from 'gsap/Draggable';

gsap.registerPlugin(ScrollTrigger, Draggable);

document.addEventListener('DOMContentLoaded', () => {
    gsap.from('.herovid1', {
		duration: 1,
		opacity: 0,
		y: -200,
		ease: 'power2.out',
		delay:  0.5
		}
	);
	gsap.from('.herovid2', {
		duration: 1,
		opacity: 0,
		y: 200,
		ease: 'power2.out',
		delay:  0.5
		}
	);

    // Fade up elements animation
    const fadeUpElements = document.querySelectorAll('.anmi-fadeup');
    fadeUpElements.forEach((element, index) => {
        gsap.from(element, {
            scrollTrigger: {
                trigger: element,
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
            duration: 1,
            opacity: 0,
            y: 50,
            ease: 'power2.out',
            stagger: 0.15,
            delay: index * 0.15
        });
    });

    // Box fade-up elements animation
    const boxfadeUpElements = document.querySelectorAll('.box-fadeup');
    boxfadeUpElements.forEach((element, index) => {
        gsap.from(element, {
            scrollTrigger: {
                trigger: element,
                start: 'top-=10 100%',
                toggleActions: 'play none none none',
            },
            duration: 1,
            opacity: 0,
            y: 50,
            ease: 'power2.out',
            stagger: 0.15,
            delay: index * 0.15
        });
    });

    // Fade left elements animation
    const fadeLeftElements = document.querySelectorAll('.anmi-fadeleft');
    fadeLeftElements.forEach((element, index) => {
        gsap.from(element, {
            scrollTrigger: {
                trigger: element,
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
            duration: 1.5,
            opacity: 0,
            x: -250,
            ease: 'power2.out',
            stagger: 0.15,
            delay: index * 0.15
        });
    });

	    // Fade left elements animation
		const fadeRightElements = document.querySelectorAll('.anmi-faderight');
		fadeRightElements.forEach((element, index) => {
			gsap.from(element, {
				scrollTrigger: {
					trigger: element,
					start: 'top 80%',
					toggleActions: 'play none none none',
				},
				duration: 1.5,
				opacity: 0,
				x: 250,
				ease: 'power2.out',
				stagger: 0.15,
				delay: index * 0.15
			});
		});

    // Fade bottom elements animation
    const fadeBottomElements = document.querySelectorAll('.anmi-fadebottom');
    fadeBottomElements.forEach((element, index) => {
        gsap.from(element, {
            scrollTrigger: {
                trigger: element,
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
            duration: 1,
            opacity: 0,
            y: 50,
            ease: 'power2.out',
            stagger: 0.15,
            delay: index * 0.15
        });
    });

    // Parallax block scroll animations
    gsap.fromTo('.para-100200',
        { y: -100 },
        {
            y: 200,
            scrollTrigger: {
                trigger: '.parrablock',
                start: 'top bottom',
                end: 'bottom top',
                scrub: true,
            }
        }
    );

    gsap.fromTo('.para100-100',
        { y: 100 },
        {
            y: -100,
            scrollTrigger: {
                trigger: '.parrablock',
                start: 'top bottom',
                end: 'bottom top',
                scrub: true,
            }
        }
    );

// Video boxes animation
const videoBoxes = document.querySelectorAll('.videoboxes .videobox');
videoBoxes.forEach((box, index) => {
    const timeline = gsap.timeline({
        delay: index * 0.2 // Stagger the start of each box animation
    });

    if (index % 2 === 0) {
        // Even boxes fall from the top
        timeline
            .from(box, {
                y: -200,
                opacity: 0,
                duration: 2.5,
                ease: "power2.out"
            })
            .to(box, {
                y: "-=20", // Float slightly down
                duration: 1.5,
                ease: "sine.inOut",
                repeat: 3, // Repeat the float 3 times
                yoyo: true // Reverse the float direction
            }); // No overlap, starts after the initial animation
    } else {
        // Odd boxes rise from the bottom
        timeline
            .from(box, {
                y: 200,
                opacity: 0,
                duration: 2.5,
                ease: "power2.out"
            })
            .to(box, {
                y: "+=20", // Float slightly up
                duration: 1.5,
                ease: "sine.inOut",
                repeat: 3, // Repeat the float 3 times
                yoyo: true // Reverse the float direction
            }); // No overlap, starts after the initial animation
    }
});

});

export default function initInitGsap() {
    gsap.registerPlugin(ScrollTrigger, Draggable);
}
